<template lang="pug">
  v-dialog(
    max-width="800px"

    :value="dialog"
    @input="$emit('input', $event)"
    scrollable
    @keydown.esc="closeModal"
    @keydown.enter="$emit('save')"
    @click:outside="closeModal"
  )
    template(#activator="{ on, attrs }")
      slot(name="activator" :on="on" :attrs="attrs")
    v-card
      v-card-title(style="padding-top: 5px;")
        v-layout
          slot(name="title")
      v-card-text
        v-layout(wrap)
          v-flex(xs12)
            v-container.px-0(fluid)
              v-layout
                v-flex
                  slot
          v-btn(v-if="saveButton" :color="!loading ? 'success' : 'disabled'" :disabled="loading" @click.stop="confirm")
            slot(name="save-button") Сохранить
          v-spacer
          v-btn(color="error" @click.stop="closeModal")
            slot(name="cancel-button") Отменить
</template>

<script>
export default {
  data() {
    return {
    };
  },
  props: {
    dialog: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    saveButton: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
  },
  methods: {
    closeModal() {
      this.$emit('update:dialog', !this.dialog);
      this.$emit('close');
    },
    confirm() {
      if (!this.loading) {
        this.$emit('confirm');
      }
    },
  },
};
</script>
